<script>
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

const formatTabDate = date => dayjs(date).format('DD.MM dd');

export default {
  props: {
    getListService: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      isFetching: false,
      data: [],
      selectedDate: '',
    };
  },
  computed: {
    selectedData () {
      return this.data[this.selectedDate];
    },
    dateIsWeekend () {
      return this.$store.getters['weekends/dateIsWeekend'];
    },
  },
  methods: {
    handleDateSelect (e) {
      const { date } = e.target.dataset;

      if (date) {
        this.selectedDate = date;
      }
    },
  },
  async created () {
    this.isFetching = true;

    const currentDate = dayjs().startOf('day');

    this.selectedDate = currentDate.format('YYYY-MM-DD');

    this.data = await this.getListService();

    this.isFetching = false;
  },
  render () {
    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, data, selectedDate, selectedData } = this;

    return (
      <div>
        <div
          role="presentation"
          class={$style.tabs}
          onClick={this.handleDateSelect}
        >
          {Object.keys(data).map(date => {
            const isActive = date === selectedDate;
            const isWeekend = this.dateIsWeekend(date);

            const { skippersCount } = data[date] || {};
            let badgeState = null;

            if (skippersCount === 0) {
              badgeState = $style.tabsItemBadge_good;
            } else if (skippersCount < 10) {
              badgeState = $style.tabsItemBadge_warn;
            } else if (typeof skippersCount !== 'undefined') {
              badgeState = $style.tabsItemBadge_bad;
            }

            return (
              <button
                key={date}
                class={[
                  $style.tabsItem,
                  {
                    [$style.tabsItem_active]: isActive,
                    [$style.tabsItem_weekend]: isWeekend,
                  },
                ]}
                data-date={date}
                type="button"
              >
                <span>
                  {formatTabDate(date)}
                </span>
                {!isWeekend && (
                  <span class={[$style.tabsItemBadge, badgeState]}>
                    {skippersCount || '-'}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {selectedData && (
          selectedData.skippers.length ? (
            <div class={$style.skippers}>
              {selectedData.skippers.map(worker => (
                <span
                  key={worker.id}
                  class={$style.skippersItem}
                >
                  <span class={$style.skippersItemName}>
                    {worker.name}
                  </span>
                </span>
              ))}
            </div>
          ) : (
            <div class={$style.empty}>
              В этот день все отметились 🎉
            </div>
          )
        )}

        {!selectedData && (
          <div class={$style.empty}>
            За этот день нет записей...
          </div>
        )}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.tabs {
  display: flex;
  max-width: 100%;
  overflow: auto;

  &Item {
    @include button-reset();

    align-items: center;
    border-bottom: 2px solid $color-gray-lighter;
    display: flex;
    flex: 1;
    padding: 8px 16px;
    white-space: nowrap;
    width: 100%;

    &:hover,
    &:focus {
      border-bottom-color: $color-primary-lightest;
    }

    &:focus {
      outline: 0;
    }

    & > * {
      pointer-events: none;
    }

    &_active {
      &,
      &:hover,
      &:focus {
        border-bottom-color: $color-primary;
      }
    }

    &_weekend {
      color: $color-gray-darker;
    }

    &Badge {
      background-color: $color-gray;
      border-radius: 1em;
      color: $color-white;
      display: inline-block;
      font-size: .75em;
      height: 1.325em;
      line-height: 1.35;
      margin-left: 1em;
      min-width: 1.325em;
      padding: 0 .375em;
      text-align: center;

      &_good {
        background-color: $color-green;
      }

      &_warn {
        background-color: $color-accent;
      }

      &_bad {
        background-color: $color-red;
      }
    }
  }
}

.skippers {
  display: flex;
  flex-wrap: wrap;
  padding: .5em 0;

  &Item {
    align-items: center;
    display: inline-flex;
    flex-grow: 0;
    flex-shrink: 0;
    padding: .25em 0;
    width: 20%;

    &Name {
      font-size: .875em;
    }
  }

  &Footer {
    flex-shrink: 0;
    padding: .25em 0;
    width: 100%;
  }

  &CopyBtn {
    @include button-reset();

    font-size: .825em;
  }
}

.empty {
  color: $color-gray-darkest;
  padding: 1em 0;
  text-align: center;
}
</style>
